import { FilterStatusesCheckboxesState, FilterStatusesDropListData } from './filter-statuses.types';
import { AnyObject } from '../../../../common/interfaces';
import { objectUtility } from '../../../../utils/object/object';

export const getGroupedEvents = (filteredDropListData: FilterStatusesDropListData[]) => {
  const result: AnyObject = {};
  filteredDropListData.forEach(item => {
    if (!item.uds_app_status_filter_value?.label) {
      result.Andere = [...(result.Andere || []), item];
      return;
    }
    result[item.uds_app_status_filter_value?.label] = [
      ...(result[item.uds_app_status_filter_value?.label] || []),
      item
    ];
  });
  return result;
};

export const getDefaultCheckboxesState = (
  filteredDropListData: FilterStatusesDropListData[],
  filterForServer: string[] | null
): FilterStatusesCheckboxesState => {
  const defaultCheckboxesState: FilterStatusesCheckboxesState = {};
  const groupedEvents = getGroupedEvents(filteredDropListData);

  objectUtility.entries(groupedEvents).forEach(([key, value]) => {
    defaultCheckboxesState[key] = {
      checked: value.every((item: FilterStatusesDropListData) =>
        filterForServer?.includes(item.uds_fahrzeugbestellungeneventdescriptionid)
      ),
      indeterminate:
        value.some((item: FilterStatusesDropListData) =>
          filterForServer?.includes(item.uds_fahrzeugbestellungeneventdescriptionid)
        ) &&
        value.some(
          (item: FilterStatusesDropListData) =>
            !filterForServer?.includes(item.uds_fahrzeugbestellungeneventdescriptionid)
        ),
      items: value.map((item: FilterStatusesDropListData) => ({
        checked: filterForServer?.includes(item.uds_fahrzeugbestellungeneventdescriptionid),
        indeterminate: false,
        id: item.uds_fahrzeugbestellungeneventdescriptionid
      }))
    };
  });

  return defaultCheckboxesState;
};
